export const SET_LOADED_STATUS = "SET_LOADED_STATUS";
export const SET_ALL_CHALLENGE_PACKAGES = "SET_ALL_CHALLENGE_PACKAGES";
export const SET_CHALLENGE_PACKAGES_FOR_BUILDER =
  "SET_CHALLENGE_PACKAGES_FOR_BUILDER";
